import type { KitType } from '@repo/types';
import type { AgeGroup } from '@repo/utils';

export const GATE_1_SLIDE_IDS = {
  WHAT_THIS_PAGE_SHOWS: 'what_this_page_shows',
  NOT_A_DIAGNOSIS: 'not_a_diagnosis',
  ASSOCIATION_NOT_CAUSE: 'association_not_cause',
  FLAG_NOT_PRESENCE: 'flag_not_presence',
  MICROBIOME_CONNECTIONS: 'microbiome_connections',
  SENSITIVE_METRIC_FLAGS: 'sensitive_metric_flags',
  REMINDERS: 'reminders',
} as const;

export type Gate1SlideId =
  (typeof GATE_1_SLIDE_IDS)[keyof typeof GATE_1_SLIDE_IDS];

export type Gate = 'gate_1' | 'gate_2';

export type GateViewerRole =
  | 'user'
  | 'specialist_impersonation'
  | 'prac_impersonation';

export type GateSharedProps = {
  experience: 'gut_body_connections' | 'legacy_conditions';
  entry_surface:
    | 'home_card'
    | 'conditions_page'
    | 'condition_detail'
    | 'deep_link';
  kit_type: KitType;
  body_variant: AgeGroup;
  viewer_role: GateViewerRole;
};

type Gate1Props = GateSharedProps & { gate: 'gate_1' };

type Gate2Props = GateSharedProps & {
  gate: 'gate_2';
  condition_id: number;
  condition: string;
};

export type GateUserTraits = {
  gate_1_completed_at: string;
};

export type GateEventPropertiesMap = {
  'Gate 1 Viewed': Gate1Props & { slide_count: number };
  'Gate 1 Slide Advanced': Gate1Props & {
    from_slide: Gate1SlideId;
    to_slide: Gate1SlideId;
    direction: 'forward' | 'backward';
    seconds_on_slide: number;
  };
  'Gate 1 Completed': Gate1Props & {
    total_seconds: number;
    back_navigations: number;
  };
  'Gate 2 Viewed': Gate2Props & { marked_in_survey: boolean };
  'Gate 2 Acknowledged': Gate2Props & { seconds_to_acknowledge: number };
  'Gate 2 Backed Out': Gate2Props & { seconds_on_gate: number };
};
